<template>
    <li class="cursus-step text-lowercase" :class="classes">
        <div class="cursus-step__content position-relative">
            <template v-if="done">
                <router-link :to="step.route" custom v-slot="{ href, navigate }">
                    <a class="stretched-link" :href="href" :aria-label="step.label" @click="navigate"></a>
                </router-link>
            </template>
            <span class="cursus-step__circle">{{ index }}</span>
            <span class="cursus-step__text">{{ step.label }}</span>
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            step: Object,
            done: Boolean,
            active: Boolean,
            index: Number,
        },
        computed: {
            classes() {
                return {
                    'cursus-step--success': this.done && !this.active,
                    'cursus-step--active': this.active,
                }
            },
        },
    }
</script>
